import { PermissionData, usePermissions } from "../query/api";

export type Permission = {
  section: string;
  function: string;
};

export const satisfyPermissionSets = (permissionData: PermissionData | undefined, requiredPermissionSets: Permission[][] = [[]], requireSuperPlusAdmin: boolean = false) => {
  return requiredPermissionSets.some(permissionSet => permissionSet.every(
    requiredPermission => permissionData?.sections?.find(section => section.section === requiredPermission.section)?.functions?.find(permission=>permission.function === requiredPermission.function) ?? false)
  ) && (!(requireSuperPlusAdmin ?? false) || permissionData?.roleCode === 'SUPERPLUS_ADMIN');            
}

export const useSatisfyPermissionSets = (requiredPermissionSets: Permission[][] = [[]], requireSuperPlusAdmin: boolean = false) => {
  const { data } = usePermissions();
  return satisfyPermissionSets(data?.data, requiredPermissionSets, requireSuperPlusAdmin)
}

export const useRequirePermissionSets = (requiredPermissionSets: Permission[][] = [[]]) => { 
  const { data } = usePermissions();
  return requiredPermissionSets.some(permissionSet => permissionSet.every(
    requiredPermission => data?.data?.sections?.find(section => section.section === requiredPermission.section)?.functions?.find(permission=>permission.function === requiredPermission.function) ?? false)
  );
};

export const useIsSuperPlusAdmin = () => { 
  const { data } = usePermissions();
  return data?.data?.roleCode === 'SUPERPLUS_ADMIN';
}